import { ReferAndEarnRouterPath } from "@src/appV2/Accounts/ReferAndEarn/paths";
import { WorkplaceReferralRouterPath } from "@src/appV2/Accounts/WorkplaceReferrals/paths";
import { RootPaths } from "@src/appV2/App/paths";
import { WorkplaceReviewsRouterPath } from "@src/appV2/redesign/Workplace/Review/paths";

import { OnboardingRouterPath } from "./onboardingRoute";
import { TabRouterPath } from "./tabRoute";
import { WelcomeRouterPath } from "./welcomeRoute";

export const RouterPath = {
  ...RootPaths,
  ...WelcomeRouterPath,
  ...OnboardingRouterPath,
  ...TabRouterPath,
  ...WorkplaceReviewsRouterPath,
  ...WorkplaceReferralRouterPath,
  ...ReferAndEarnRouterPath,
};
